import { render, staticRenderFns } from "./steps.vue?vue&type=template&id=c8764156&scoped=true&"
import script from "./steps.vue?vue&type=script&lang=js&"
export * from "./steps.vue?vue&type=script&lang=js&"
import style0 from "./steps.vue?vue&type=style&index=0&id=c8764156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8764156",
  null
  
)

export default component.exports